<template>
  <v-layout row wrap>
    <!-- Upload dialog form -->
    <!-- <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="uploadDialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Upload New Workflow</v-card-title>
            <v-container>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Select file"
                      @click="pickFile"
                      v-model="fileName"
                      prepend-icon="attach_file"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      label="Please choose your CSV file"
                      accept=".csv"
                      ref="fileInput"
                      required
                      @change="onFileChanged"
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="uploadDialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="uploadFile">upload</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>-->
    <!-- End of Upload dialog form -->
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Delete selected workflow?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected workflow.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn
                color="accent"
                flat
                @click="deleteWorkflowById"
                :loading="getLoading"
                :disable="getLoading"
              >delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Search</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-form @submit.prevent="frmSearch">
                <v-container grid-list-xl class="pa-0 ma-0" fluid>
                  <v-layout row wrap>
                    <v-flex xs12 md3>
                      <v-select
                        v-bind:items="getAllCompanies"
                        v-model="workflow.companyId"
                        label="Company code"
                        item-value="id"
                        :error-messages="errors.collect('company code')"
                        v-validate="'required'"
                        data-vv-name="company code"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ data.item.company_code }}</template>
                        <template
                          slot="item"
                          slot-scope="data"
                        >{{ data.item.company_code }} - {{ data.item.description }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-select
                        v-bind:items="getAllDivisions"
                        v-model="workflow.divisionId"
                        label="Division"
                        item-value="id"
                        :error-messages="errors.collect('division')"
                        v-validate="'required'"
                        data-vv-name="division"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ data.item.initial }}</template>
                        <template
                          slot="item"
                          slot-scope="data"
                        >{{ data.item.initial }} - {{ data.item.description }}</template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 md3>
                      <v-select
                        v-bind:items="getAllDepartments"
                        v-model="workflow.departmentId"
                        label="Department"
                        item-value="id"
                        :error-messages="errors.collect('department')"
                        v-validate="'required'"
                        data-vv-name="department"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ data.item.description }}</template>
                        <template
                          slot="item"
                          slot-scope="data"
                        >{{ data.item.initial }} - {{ data.item.description }}</template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 md3>
                      <v-select
                        v-bind:items="getAllPlants"
                        v-model="workflow.plantId"
                        label="Plant"
                        item-value="id"
                        clearable
                      >
                        <template slot="selection" slot-scope="data">{{ data.item.plant }}</template>
                        <template
                          slot="item"
                          slot-scope="data"
                        >{{ data.item.plant }} - {{ data.item.description }}</template>
                      </v-select>
                    </v-flex>

                     <v-flex xs12 md3>
                      <v-select
                        v-bind:items="purchaseType"
                        v-model="workflow.purchaseType"
                        label="Document type"
                        item-value="type"
                        item-text="text"
                        clearable
                      >
                      </v-select>
                    </v-flex>

                    <v-btn color="accent" @click="frmSearch()">search</v-btn>
                    <v-btn dark color="accent" to="/workflow/new">new</v-btn>
                    <v-btn dark color="accent" @click="saveToCSV()">
                      <v-icon left dark>cloud_download</v-icon>Download
                    </v-btn>
                    <v-flex xs6 md2>
                      <!-- <v-btn color="grey lighten-3" @click="loadWorkflow()">show all</v-btn> -->
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-card>
        <v-card-title>
          <h1 class="title">Details</h1>
          <!-- <v-btn dark color="accent" to="/workflow/new">new</v-btn>
          <v-btn dark color="accent" @click="saveToCSV()" v-if="this.getWorkflow.length > 0">
          <v-btn dark color="accent" @click="saveToCSV()">
            <v-icon left dark>cloud_download</v-icon>Download
          </v-btn>
          <v-btn dark color="accent" @click="uploadDialog = true">
            <v-icon left dark>cloud_upload</v-icon>Upload
          </v-btn>-->
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="getLoading"
            :headers="headers"
            :items="getWorkflow"
            :search="search"
            :rows-per-page-items="[10, 15, 20]"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" style="min-width: 160px;">
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    @click="editWorkflowById(props.item.id)"
                    color="accent lighten-1"
                    slot="activator"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Change</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    @click="toggleDialog(props.item.id)"
                    color="error lighten-1"
                    slot="activator"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{ props.item.company_code}}</td>
              <td class="text-xs-left">{{ props.item.division_name}}</td>
              <td class="text-xs-left">{{ props.item.department_code}}</td>
              <td class="text-xs-left">{{ props.item.plant_code}}</td>
              <td class="text-xs-left">{{ props.item.purchaseType}}</td>
              <td class="text-xs-left">{{ props.item.is_contract === true ? 'Yes' : 'No'}}</td>
              <td class="text-xs-left">{{ props.item.requisitioner}}</td>
              <td class="text-xs-right">{{ props.item.string_value}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel1s === null ? '' : props.item.employeeLevel1s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel2s === null ? '' : props.item.employeeLevel2s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel3s === null ? '' : props.item.employeeLevel3s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel4s === null ? '' : props.item.employeeLevel4s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel5s === null ? '' : props.item.employeeLevel5s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel6s === null ? '' : props.item.employeeLevel6s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel7s === null ? '' : props.item.employeeLevel7s.toString()}}</td>
              <td class="text-xs-right">{{ props.item.employeeLevel8s === null ? '' : props.item.employeeLevel8s.toString()}}</td>
            </template>
          </v-data-table>

          <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
            {{ text }}
            <v-btn flat dark @click.native="snackbar = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-snackbar>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>



<script>
import { mapActions, mapGetters } from 'vuex'
import Papa from 'papaparse'
import Blob from 'blob'
import FileSaver from 'file-saver'

export default {
  name: 'workflow-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      pagination: {},
      totalWorkflow: 0,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      uploadDialog: false,
      csvFile: '',
      fileName: '',
      purchaseType: [
        {
          type: 'PR',
          text: 'Purchase Requisition'
        },
        {
          type: 'PO',
          text: 'Purchase Order'
        }
      ],
      workflow: {
        companyId: '',
        plantId: '',
        divisionId: '',
        departmentId: '',
        purchaseType: '',
        page: null
      },
      items: [],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Company code',
          align: 'left',
          value: 'company_code'
        },
        {
          text: 'Division',
          align: 'left',
          value: 'division_name'
        },
        {
          text: 'Department',
          align: 'left',
          value: 'department_code'
        },
        {
          text: 'Plant',
          align: 'left',
          value: 'plant_code'
        },
        {
          text: 'Type',
          align: 'left',
          value: 'purchaseType'
        },
        {
          text: 'With contract',
          align: 'left',
          value: 'is_contract'
        },
        {
          text: 'Requisitioner',
          align: 'left',
          value: 'requisitioner'
        },
        {
          text: 'Total net value approval limit',
          align: 'right',
          value: 'string_value',
          width: '1%'
        },
        {
          text: 'Level 1',
          align: 'left',
          value: 'employeeLevel1s'
        },
        {
          text: 'Level 2',
          align: 'left',
          value: 'employeeLevel2s'
        },
        {
          text: 'Level 3',
          align: 'left',
          value: 'employeeLevel3s'
        },
        {
          text: 'Level 4',
          align: 'left',
          value: 'employeeLevel4s'
        },
        {
          text: 'Level 5',
          align: 'left',
          value: 'employeeLevel5s'
        },
        {
          text: 'Level 6',
          align: 'left',
          value: 'employeeLevel6s'
        },
        {
          text: 'Level 7',
          align: 'left',
          value: 'employeeLevel7s'
        },
        {
          text: 'Level 8',
          align: 'left',
          value: 'employeeLevel8s'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      csv: []
    }
  },
  watch: {
    // pagination: {
    //   handler() {
    //     this.workflow.page = this.pagination.page
    //     this.fetchWorkflow(this.workflow)
    //     this.items = this.getWorkflow
    //     this.pagination.totalItems = this.items.totalItems
    //     this.totalWorkflow = this.items.totalItems
    //   },
    //   deep: true
    // }
  },
  methods: {
    ...mapActions([
      'fetchWorkflow',
      'deleteWorkflow',
      'fetchAllCompanies',
      'fetchAllDivisions',
      'fetchAllDepartments',
      'fetchAllPlants',
      'searchWorkflow',
      'uploadWorkflow'
    ]),

    editWorkflowById: function(id) {
      this.$router.push({ name: 'changeWorkflow', params: { id: id } })
    },

    deleteWorkflowById: function() {
      this.deleteWorkflow(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    toggleDialog: function(id) {
      this.selectedId = id
      this.dialog = true
    },

    loadWorkflow: function() {
      this.fetchWorkflow(this.workflow)
      this.items = this.getWorkflow
      this.pagination.totalItems = this.items.total
      this.totalWorkflow = this.items.totalItems
    },

    frmSearch: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.searchWorkflow(this.workflow)
          this.items = this.getWorkflow
          this.pagination.totalItems = this.items.total
          this.totalItems = this.items.total
        }
      })
    },

    parseJSONtoCSV() {
      this.csv = []
      this.getWorkflow.forEach(element => {
        let row = {
          'Company code': null,
          Plant: null,
          Division: null,
          Department: null,
          'Max limit': null,
          Requisitioner: null,
          Type: null,
          'Contract': null,
          'Level 1': '',
          'Level 2': '',
          'Level 3': '',
          'Level 4': '',
          'Level 5': '',
          'Level 6': '',
          'Level 7': '',
          'Level 8': ''
        }

        row['Company code'] = element.company_code
        row['Plant'] = element.plant_code
        row['Division'] = element.division_name
        row['Department'] = element.department_code
        row['Max limit'] = element.string_value
        row['Requisitioner'] = element.requisitioner
        row['Type'] = element.purchaseType
        row['Contract'] = element.is_contract
        row['Level 1'] =
          element.employeeLevel1s !== null ? '"' + element.employeeLevel1s.toString() + '"' : ``
        row['Level 2'] =
          element.employeeLevel2s !== null ? '"' + element.employeeLevel2s.toString() + '"' : ``
        row['Level 3'] =
          element.employeeLevel3s !== null ? '"' + element.employeeLevel3s.toString() + '"' : ``
        row['Level 4'] =
          element.employeeLevel4s !== null ? '"' + element.employeeLevel4s.toString() + '"' : ``
        row['Level 5'] =
          element.employeeLevel5s !== null ? '"' + element.employeeLevel5s.toString() + '"' : ``
        row['Level 6'] =
          element.employeeLevel6s !== null ? '"' + element.employeeLevel6s.toString() + '"' : ``
        row['Level 7'] =
          element.employeeLevel7s !== null ? '"' + element.employeeLevel7s.toString() + '"' : ``
        row['Level 8'] =
          element.employeeLevel8s !== null ? '"' + element.employeeLevel8s.toString() + '"' : ``
        this.csv.push(row)
      })
      const config = {
        quotes: true,
        headers: true,
        worker: true
      }
      return Papa.unparse(this.csv, config)
    },

    saveToCSV() {
      const blob = new Blob([this.parseJSONtoCSV()], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'workflow_configuration.csv')
    },
    pickFile() {
      this.$refs.fileInput.click()
    },

    onFileChanged(event) {
      const files = event.target.files
      this.csvFile = files[0]
      this.fileName = files[0].name
    },

    uploadFile() {
      let workflow = []
      Papa.parse(this.csvFile, {
        header: true,
        skipEmptyLines: true,
        complete: results => {
          console.log(results)
          workflow = results.data
          this.uploadWorkflow(workflow)
            .then(response => {
              this.uploadDialog = false
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  },
  mounted: function() {
    // this.loadWorkflow()
    this.fetchAllCompanies()
    this.fetchAllDivisions()
    this.fetchAllDepartments()
    this.fetchAllPlants()
    // this.fetchAllApprovalProfiles()
  },
  computed: {
    ...mapGetters([
      'getWorkflow',
      'getLoading',
      'getResponse',
      'getAllCompanies',
      'getAllDivisions',
      'getAllDepartments',
      'getAllPlants',
      'getApprovalProfiles'
    ])
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/workflow/WorkflowDetail.vue